<template>
	<form @submit.prevent="submit">
		<div class="fieldset dialogue">
			<TwoColumn class="fieldset">
				<FieldInput
					required
					type="number"
					info="Between 1 and 25"
					min="1"
					max="25"
					name="roundSizeWeb"
					label="Ideas per round (web)"
					v-model="fields.roundSizeWeb"
					:errors="errors.roundSizeWeb"
				/>
				<FieldInput
					required
					type="number"
					info="Between 1 and 25"
					min="1"
					max="25"
					name="roundSizeWall"
					label="Ideas per round (wall)"
					v-model="fields.roundSizeWall"
					:errors="errors.roundSizeWall"
				/>
			</TwoColumn>
			<TwoColumn class="fieldset">
				<FieldInput
					required
					type="number"
					info="Between 10 and 600 seconds"
					min="10"
					max="600"
					name="leaderboardRefreshInterval"
					label="Leaderboard refresh interval (sec)"
					v-model="fields.leaderboardRefreshInterval"
					:errors="errors.leaderboardRefreshInterval"
				/>
				<FieldInput
					required
					type="number"
					info="Between 10 and 600 seconds"
					min="10"
					max="600"
					name="galleryRefreshInterval"
					label="Gallery refresh interval (sec)"
					v-model="fields.galleryRefreshInterval"
					:errors="errors.galleryRefreshInterval"
				/>
			</TwoColumn>
			<label>Dialogue settings*</label>
			<Accordion>
				<AccordionItem label="Poked" :error="false">
					<p>Things to say when the face is poked by a user.</p>
					<DialogueEditor v-model="fields.dialogue.value.poked" />
				</AccordionItem>
			</Accordion>
		</div>
		<div>
			<SubmitButton
				class="btn btn--submit"
				label="Save"
				v-bind="submitButton"
			/>
		</div>
	</form>
</template>

<script>
import form from '@/mixins/form'
import TwoColumn from '@/components/shared/TwoColumn'
import FieldInput from '@/components/shared/FieldInput'
import Accordion from '@/components/admin/Accordion'
import AccordionItem from '@/components/admin/AccordionItem'
import DialogueEditor from '@/components/admin/DialogueEditor'
import SubmitButton from '@/components/shared/SubmitButton'

export default {
	name: 'GlobalsForm',
	mixins: [form.globals],
	components: {
		TwoColumn,
		FieldInput,
		Accordion,
		AccordionItem,
		DialogueEditor,
		SubmitButton
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';
@import '~scss/mq';

.fieldset {
	margin-bottom: 2rem;

	&.dialogue label {
		@extend %field-label;
		margin-bottom: 0.75rem;
	}
}
</style>
